const SLOT_GAP = 5;

export { SLOT_GAP };
//# sourceMappingURL=constants.mjs.map
